import React from 'react';
import PropTypes from 'prop-types';
import { getPlatformConfig } from '../../containers/Onboarding/oauth/platformConfig';

const LIST_STYLE = { paddingLeft: '18px', marginBottom: '8px' };

// Renders requirements, capabilities and connection methods for a platform from
// the shared platformConfig so every page shows the same info.
export default function PlatformInfo({ platform }) {
  const config = getPlatformConfig(platform);
  if (!config) return null;
  const { requirements, capabilities, connectionMethods, connectionNote, onboardingSteps } = config;

  return (
    <div>
      {config.description && <p>{config.description}</p>}
      {requirements && requirements.length > 0 && (
        <>
          <strong>Requirements</strong>
          <ul style={LIST_STYLE}>
            {requirements.map(item => <li key={item}>{item}</li>)}
          </ul>
        </>
      )}
      {capabilities && capabilities.length > 0 && (
        <>
          <strong>Capabilities</strong>
          <ul style={LIST_STYLE}>
            {capabilities.map(item => <li key={item}>{item}</li>)}
          </ul>
        </>
      )}
      {connectionMethods && connectionMethods.length > 0 && (
        <>
          <strong>How to connect{connectionMethods.length > 1 ? ' (options)' : ''}</strong>
          {connectionNote && <div><em>{connectionNote}</em></div>}
          <ol style={LIST_STYLE}>
            {connectionMethods.map(method => (
              <li key={method.name}>
                {method.name}
                <ul style={{ paddingLeft: '18px' }}>
                  {method.steps.map(step => <li key={step}>{step}</li>)}
                </ul>
              </li>
            ))}
          </ol>
        </>
      )}
      {onboardingSteps && onboardingSteps.length > 0 && (
        <>
          <strong>Next steps after connecting</strong>
          <ol style={LIST_STYLE}>
            {onboardingSteps.map(step => (
              <li key={step.title}>
                {step.title}
                <ul style={{ paddingLeft: '18px' }}>
                  {step.details.map(detail => <li key={detail}>{detail}</li>)}
                </ul>
              </li>
            ))}
          </ol>
        </>
      )}
    </div>
  );
}

PlatformInfo.propTypes = {
  platform: PropTypes.string.isRequired,
};
